import React, { useEffect, useState } from 'react';
import { FaTimes, FaCalendarAlt, FaCheck, FaSearch, FaFilter, FaInbox } from "react-icons/fa";
// import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';
import { API } from 'aws-amplify';
import Moment from 'react-moment';
import {Column, Table, AutoSizer } from 'react-virtualized';
import 'react-virtualized/styles.css'; 

import '../../../styles/compact-filters.css';
import '../../../components/PageHeader/PageHeader.css';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { useI18n } from '../../../i18n';
import './TaskCosts.css';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import DatePickerPopperContainer from '../../../components/DatePickerPopperContainer';

import { useToasts } from 'react-toast-notifications';

const FILTERS_KEY = "taskCostsFilters";

const COST_KEYS = [
	'materials',
	'callout_nr',
	'callout_rate',
	'callout_subtotal',
	'onsite_nr',
	'onsite_rate',
	'onsite_subtotal',
	'total_cost',
	'contractor',
	'contractor_ref',
];

const COST_ROW_HEIGHT = 268;

const clipText = (value, max) => {
	if (!value) return '';
	return value.length > max ? `${value.substring(0, max)}...` : value;
};

const CostInput = ({ item, id, type = 'number', placeholder = '', readOnly = false, extraClass = '', onChange }) => (
	<Form.Control
		id={id}
		data-id={item.taskId}
		as="input"
		value={item[id]}
		onChange={onChange}
		className={`cost-input${readOnly ? ' is-calculated' : ''}${extraClass ? ` ${extraClass}` : ''}`}
		type={type}
		step={type === 'number' ? '0.01' : undefined}
		placeholder={placeholder}
		readOnly={readOnly}
		tabIndex={readOnly ? -1 : undefined}
	/>
);

const TaskCosts = (props) => {
	const { t } = useI18n();
	const [tasks, setTasks] = useState([]);
	const [taskList, setTaskList] = useState([]);
	const [tasksInit, setTasksInit] = useState([]);
    const [dateFrom, setDateFrom] = useState('');
	const [dateTo, setDateTo] = useState('');
	const [siteRef,setSiteRef] = useState('');
	const [taskRef,setTaskRef] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [isTaskLoading, setIsTaskLoading] = useState(false);
	const [contractorList, setContractorList] = useState([]);
	const [filtersLoaded, setFiltersLoaded] = useState(false);
	const [tasksLoaded, setTasksLoaded] = useState(false);

    const { addToast } = useToasts();
    const params = { 
        headers: {
			'x-api-key': process.env.REACT_APP_API_KEY,        
			'Accept': 'application/json',
			'Content-Type': 'application/json',
        },
    }

	// Load tasks
	useEffect(()=>{
		const fetchTasks = async () => {
			setIsLoading(true);
			setTasksLoaded(false);
			let tasks = await API.get('task_costs_upd','/', params)
						
			tasks = tasks.filter(item => item.date_completed !== undefined)

			for (let i = 0; i < tasks.length; i++) {

				if (tasks[i].hp_site) {
					tasks[i].hp_site_str = "Yes"
				}else{
					tasks[i].hp_site_str = "No"
				}
				
				if (tasks[i].date_created){
					tasks[i].date_created_str = (
						<div className="date-cell">
							<Moment local format='DD-MM-YYYY' date={ tasks[i].date_created } />
							<span className="date-cell-time">
								<Moment local format='HH:mm' date={ tasks[i].date_created } />
							</span>
						</div>
					);
				}
				if (tasks[i].date_completed){
					tasks[i].date_completed_str = (
						<div className="date-cell">
							<Moment local format='DD-MM-YYYY' date={ tasks[i].date_completed } />
							<span className="date-cell-time">
								<Moment local format='HH:mm' date={ tasks[i].date_completed } />
							</span>
						</div>
					);
				}

				tasks[i].contractor = tasks[i].contractor || ""
				tasks[i].contractor_ref = tasks[i].contractor_ref || ""

				tasks[i].materials = parseFloat(tasks[i].materials) || ""
				tasks[i].callout_nr = parseFloat(tasks[i].callout_nr) || ""
				tasks[i].callout_rate = parseFloat(tasks[i].callout_rate) || ""
				tasks[i].callout_subtotal = parseFloat(tasks[i].callout_subtotal) || ""
				tasks[i].onsite_nr = parseFloat(tasks[i].onsite_nr) || ""
				tasks[i].onsite_rate = parseFloat(tasks[i].onsite_rate) || ""
				tasks[i].onsite_subtotal = parseFloat(tasks[i].onsite_subtotal) || ""
				tasks[i].total_cost = parseFloat(tasks[i].total_cost) || ""


			}

			//sort array desc
			tasks.sort((a, b) => (a.date_created > b.date_created) ? 1 : -1)
			tasks.reverse();


			setTaskList(tasks)
			setTasks(tasks);			
			setIsLoading(false);			
			setTasksLoaded(true);
		}
		fetchTasks();	  

	}, []);

	useEffect(() => {
		if (!isTaskLoading && taskList.length > 0){
			const tasksInitial = [];
			for (let i = 0; i < taskList.length; i++) {
				tasksInitial.push({
					taskId: taskList[i].taskId,
					materials: taskList[i].materials,
					callout_nr: taskList[i].callout_nr,
					callout_rate: taskList[i].callout_rate,
					callout_subtotal: taskList[i].callout_subtotal,
					onsite_nr: taskList[i].onsite_nr,
					onsite_rate: taskList[i].onsite_rate,
					onsite_subtotal: taskList[i].onsite_subtotal,
					total_cost: taskList[i].total_cost,
					contractor: taskList[i].contractor,
					contractor_ref: taskList[i].contractor_ref
				});
			}			
			setTasksInit(tasksInitial);
			setIsTaskLoading(true);			
		}
	}, [taskList]); 

	useEffect(() => {
		if (filtersLoaded && tasksLoaded) {
			handleSearch();
		}
	}, [filtersLoaded, tasksLoaded, dateFrom, dateTo, siteRef, taskRef]);

	// Load contractors
	useEffect(()=>{
		const fetchContractors = async () => {
			
			const contractors = await API.get('settings','/CONTRACTORS', params)
			contractors.values.sort((a, b) => (a > b) ? 1 : -1)

			let list = []
			for (let i = 0; i < contractors.values.length; i++) {
				list.push(<option key={contractors.values[i]} value={contractors.values[i]}>{contractors.values[i]}</option>)
			}

			setContractorList(list);
		}
		fetchContractors();	 
	}, []);
	
	const handleClearSearch = () =>{
		setDateFrom('');
		setDateTo('');
		setSiteRef('');
		setTaskRef('');
		localStorage.removeItem(FILTERS_KEY);
	}

	const handleSearch = () => { 		
		let results = tasks;

		// Date From
		if (dateFrom){
			results = results.filter(results =>
				results.date_completed >= dateFrom.toISOString()
		)}
		
		// Date To
		if (dateTo){
			let date_to = dateTo
			date_to = date_to.setHours(23,59,59,999);
			date_to = new Date(date_to).toISOString();

			results = results.filter(results =>
				results.date_completed <= date_to
		)}
		
		// Asset
		if (siteRef){
			results = results.filter(results =>
				results.site_ref && results.site_ref.toLowerCase().includes(siteRef.toLowerCase())
		)}

		// Task Ref
		if (taskRef){
			results = results.filter(results =>
				results.task_ref && results.task_ref.toString().includes(taskRef.toString())
		)}

		//TODO search more items in the database
		setTaskList(results);		
	}
	
	const handleChange = (event) => {

		const _tempCosts = [...taskList];
		const target  = _tempCosts.find(i => i.taskId === event.target.dataset.id)
		const name = event.target.id
		const type = event.target.type

		if (type === 'number') {
			target[name] = parseFloat(event.target.value) || ""

			//calc subtotal callout
			if (name==='callout_nr' || name==='callout_rate') {
				if (target["callout_nr"]>=0 && target["callout_rate"]>=0) 
					target["callout_subtotal"] = +(parseFloat(target["callout_nr"]*target["callout_rate"])).toFixed(2);
			}

			//calc subtotal onsite
			if (name==='onsite_nr' || name==='onsite_rate') {
				if (target["onsite_nr"]>=0 && target["onsite_rate"]>=0) 
					target["onsite_subtotal"] = +(parseFloat(target["onsite_nr"]*target["onsite_rate"])).toFixed(2);
			}
	
			if (target["materials"]) target["materials"] = +(target["materials"]).toFixed(2);

			//calc total cost 
			if (target["materials"]>0 || target["callout_subtotal"]>0 || target["onsite_subtotal"]>0){
				const total_cost = (target["materials"] || 0) + (target["callout_subtotal"] || 0) + (target["onsite_subtotal"] || 0);
				target["total_cost"] = +(parseFloat(total_cost)).toFixed(2)
			}
			
		}else {
			target[name] = event.target.value || ""	
		}	

		setTaskList(_tempCosts);	
	  };

	const handleSave = item => {
		
		if (item.total_cost === ""){
			item.total_cost = 0;
			addToast(t('toast.totalCostZero'), { appearance: 'warning' });
		}

		//Clean up data before Post
		const data = Object.entries(item).reduce((a,[k,v]) => (v === null || v === '' ? a : {...a, [k]:v}), {})

		API.post('task_costs_upd', '/' + data.taskId, {      
			body: data,
			headers: {
				'x-api-key': process.env.REACT_APP_API_KEY,        
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
		})
		.then(response => {
			// console.log(response)
			addToast(t('toast.taskSaved'), { appearance: 'success' });
			setTaskList(taskList => taskList.filter(taskList => taskList.taskId !== data.taskId ));       
		}).catch(error => {
			console.log(error)
			addToast(t('toast.errorSavingTask'), { appearance: 'error' });
		}); 
		}
 

	const handleClear = (item) => {

		const _tempCosts = [...taskList];

		const original_task  = tasksInit.find(i => i.taskId === item.taskId)
		const target  = _tempCosts.find(i => i.taskId === item.taskId)

		if (original_task){
			target.contractor = original_task.contractor;
			target.contractor_ref = original_task.contractor_ref;
			target.materials = original_task.materials;
			target.callout_nr = original_task.callout_nr;
			target.callout_rate = original_task.callout_rate;
			target.callout_subtotal = original_task.callout_subtotal;
			target.onsite_nr = original_task.onsite_nr;
			target.onsite_rate = original_task.onsite_rate;
			target.onsite_subtotal = original_task.onsite_subtotal;
			target.total_cost = original_task.total_cost;
			target.total_cost = original_task.total_cost;
		}

		setTaskList(_tempCosts);
		};

	const isRowDirty = (item) => {
		const original = tasksInit.find((row) => row.taskId === item.taskId);
		if (!original) return false;
		return COST_KEYS.some((key) => String(item[key] ?? '') !== String(original[key] ?? ''));
	};

	const cellContractor = ({ cellData }) => (
		<div className="cost-stack">
			<div className="cost-pair">
				<label className="cost-field">
					<span className="cost-label">{t('common.contractor')}</span>
					<Form.Control
						as="select"
						id="contractor"
						data-id={cellData.taskId}
						value={cellData.contractor}
						className="cost-input cost-select"
						onChange={handleChange}
					>
						<option value=""></option>
						{contractorList}
					</Form.Control>
				</label>
				<label className="cost-field">
					<span className="cost-label">{t('fields.chargeable')}</span>
					<Form.Control
						id="chargeable"
						data-id={cellData.taskId}
						as="select"
						value={cellData.chargeable === 'true' ? 'Chargeable' : (cellData.chargeable === 'false' || !cellData.chargeable ? 'Fixed' : cellData.chargeable)}
						className="cost-input cost-select"
						onChange={handleChange}
					>
						<option value="Fixed">{t('fields.fixed')}</option>
						<option value="Quoted">{t('fields.quoted')}</option>
						<option value="Chargeable">{t('fields.chargeable')}</option>
					</Form.Control>
				</label>
			</div>
			<label className="cost-field">
				<span className="cost-label">{t('fields.reference')}</span>
				<CostInput item={cellData} id="contractor_ref" type="text" onChange={handleChange} />
			</label>
		</div>
	);

	const cellMaterials = ({ cellData }) => (
		<div className="cost-stack">
			<label className="cost-field">
				<span className="cost-label">{t('fields.amount')}</span>
				<CostInput item={cellData} id="materials" placeholder={t('costsUi.enterAmount')} onChange={handleChange} />
			</label>
		</div>
	);

	const cellCallOut = ({ cellData }) => (
		<div className="cost-stack">
			<div className="cost-pair">
				<label className="cost-field">
					<span className="cost-label">{t('fields.nr')}</span>
					<CostInput item={cellData} id="callout_nr" onChange={handleChange} />
				</label>
				<label className="cost-field">
					<span className="cost-label">{t('fields.rate')}</span>
					<CostInput item={cellData} id="callout_rate" extraClass="is-rate" onChange={handleChange} />
				</label>
			</div>
			<label className="cost-field is-subtotal">
				<span className="cost-label">{t('fields.subtotal')}</span>
				<CostInput item={cellData} id="callout_subtotal" extraClass="is-subtotal" onChange={handleChange} />
			</label>
		</div>
	);

	const cellLabour = ({ cellData }) => (
		<div className="cost-stack">
			<div className="cost-pair">
				<label className="cost-field">
					<span className="cost-label">{t('fields.nr')}</span>
					<CostInput item={cellData} id="onsite_nr" onChange={handleChange} />
				</label>
				<label className="cost-field">
					<span className="cost-label">{t('fields.rate')}</span>
					<CostInput item={cellData} id="onsite_rate" extraClass="is-rate" onChange={handleChange} />
				</label>
			</div>
			<label className="cost-field is-subtotal">
				<span className="cost-label">{t('fields.subtotal')}</span>
				<CostInput item={cellData} id="onsite_subtotal" extraClass="is-subtotal" onChange={handleChange} />
			</label>
		</div>
	);

	const cellTotalCost = ({ cellData }) => (
		<div className="cost-stack">
			<label className="cost-field">
				<span className="cost-label">{t('fields.calculatedTotal')}</span>
				<CostInput item={cellData} id="total_cost" readOnly placeholder={t('fields.calculatedTotal')} onChange={handleChange} />
			</label>
		</div>
	);

	const cellTaskInfo = ({ cellData }) => (
		<div className="task-info-cell">
			<div className="task-info-site">
				<span className="site-ref">{cellData.site_ref}</span>
				<span className="site-meta">
					{[cellData.district, cellData.site_address].filter(Boolean).join(' · ')}
				</span>
			</div>
			<div className="task-info-dates">
				<div className="task-info-date">
					<span className="cost-label">{t('common.created')}</span>
					{cellData.date_created_str}
				</div>
				<div className="task-info-date">
					<span className="cost-label">{t('common.completed')}</span>
					{cellData.date_completed_str}
				</div>
			</div>
			<div className="work-block">
				<span className="cost-label">{t('common.description')}</span>
				<p className={`work-text${cellData.fault_description ? '' : ' is-empty'}`}>
					{clipText(cellData.fault_description, 50) || '—'}
				</p>
			</div>
			<div className="work-block">
				<span className="cost-label">{t('fields.workCarriedOut')}</span>
				<p className={`work-text${cellData.work_completed ? '' : ' is-empty'}`}>
					{clipText(cellData.work_completed, 50) || '—'}
				</p>
			</div>
			<div className="work-block">
				<span className="cost-label">{t('fields.materials')}</span>
				<p className={`work-text${cellData.materials_description ? '' : ' is-empty'}`}>
					{clipText(cellData.materials_description, 100) || '—'}
				</p>
			</div>
		</div>
	);

	// Restore filters from localStorage on mount
	useEffect(() => {
		const saved = localStorage.getItem(FILTERS_KEY);
		if (saved) {
			const filters = JSON.parse(saved);
			setDateFrom(filters.dateFrom ? new Date(filters.dateFrom) : '');
			setDateTo(filters.dateTo ? new Date(filters.dateTo) : '');
			setSiteRef(filters.siteRef || '');
			setTaskRef(filters.taskRef || '');
		}
		setFiltersLoaded(true);
	}, []);

	// Save filters to localStorage whenever they change
	useEffect(() => {
		const filters = {
			dateFrom: dateFrom ? dateFrom.toISOString() : '',
			dateTo: dateTo ? dateTo.toISOString() : '',
			siteRef,
			taskRef,
		};
		localStorage.setItem(FILTERS_KEY, JSON.stringify(filters));
	}, [dateFrom, dateTo, siteRef, taskRef]);

	return ( 
	
	<div className="TaskCosts">
	<div>
		<PageHeader
			title={t('pages.costManager.title')}
			subtitle={t('pages.costManager.subtitle')}
			breadcrumbs={[
				{ label: t('nav.costs') },
				{ label: t('pages.costManager.title') },
			]}
			count={!isLoading ? taskList.length : undefined}
			countLabel={t('common.tasks')}
			countLoading={isLoading}
		/>
		
		<div className="row p-0 div-content">
			<div className="col-12 compact-filters cost-filters">
				<div className="filters-row filters-row-inline">
					<div className="filters-title-inline">
						<FaFilter /> {t('actions.filters')}
					</div>
					<Form.Group controlId="task_ref" className="filter-field">
						<Form.Label>{t('tasks.taskRef')}</Form.Label>
						<Form.Control 
							as="input" 
							value={taskRef}
							placeholder={t('users.search')}
							onChange={e => {setTaskRef(e.target.value)}} 
							onKeyPress={e => (e.key === 'Enter') ? handleSearch() : e.key}
							type="text" />  
					</Form.Group>

					<Form.Group controlId="site_ref" className="filter-field">
						<Form.Label>{t('tasks.siteRef')}</Form.Label>
						<Form.Control 
							as="input" 
							value={siteRef}
							placeholder={t('users.search')}
							onChange={e => {setSiteRef(e.target.value)}} 
							onKeyPress={e => (e.key === 'Enter') ? handleSearch() : e.key}
							type="text" />  
					</Form.Group>

					<Form.Group controlId="date_from" className="filter-field filter-field-date">
						<Form.Label><FaCalendarAlt className="text-secondary" /> {t('tasks.completedFrom')}</Form.Label>
						<div>
							<DatePicker dateFormat="dd/MM/yyyy" selected={dateFrom} onChange={(date_from) => {setDateFrom(date_from)}} className="form-control" popperContainer={DatePickerPopperContainer} popperPlacement="bottom-start" />
						</div>       
					</Form.Group>

					<Form.Group controlId="date_to" className="filter-field filter-field-date">
						<Form.Label><FaCalendarAlt className="text-secondary" /> {t('tasks.completedTo')}</Form.Label>
						<div>
							<DatePicker dateFormat="dd/MM/yyyy" selected={dateTo} onChange={date_to => setDateTo(date_to)} className="form-control" popperContainer={DatePickerPopperContainer} popperPlacement="bottom-start" />
						</div>
					</Form.Group>

					<div className="filter-actions">
						<Button variant="primary" className="search-btn" onClick={handleSearch}>
							<FaSearch /> {t('common.search')}
						</Button>
						<Button variant="outline-secondary" className="clear-btn" onClick={handleClearSearch} title={t('users.clearFilters')}>
							<FaTimes /> {t('common.clear')}
						</Button>
					</div>
				</div>
			</div>
			
			{(!isLoading) ? (
				(taskList.length === 0) ? (
					<div className="col-md-12 empty-state">
						<FaInbox className="empty-state-icon" />
						<div className="empty-state-text">{t('users.noRecords')}</div>
						<div className="empty-state-subtext">{t('users.tryFilters')}</div>
					</div>
				):( 
				
				<div className="col-md-12 cost-table-container">
				<AutoSizer disableHeight>
          		{({ width }) => {
				const tableWidth = Math.max(width, 1180);
				return (
				<Table
					width={tableWidth}
					height={550}
					headerHeight={40}
					rowHeight={COST_ROW_HEIGHT}
					rowCount={taskList.length}
					headerClassName="cost-table-header"
					rowClassName={({ index }) => {
						if (index < 0) return 'cost-table-header-row';
						const dirty = taskList[index] && isRowDirty(taskList[index]);
						return [
							'cost-table-row',
							index % 2 === 0 ? 'cost-table-row-even' : 'cost-table-row-odd',
							dirty ? 'is-dirty' : '',
						].filter(Boolean).join(' ');
					}}
					rowGetter={({index}) => taskList[index]}
					>
					<Column width={tableWidth * 0.05} 
						label={t('common.task')} 
						dataKey="task_ref" 
						cellDataGetter={({dataKey, rowData}) => rowData}
						cellRenderer={({ cellData })=>(
							<div className="task-ref-cell" key={cellData.taskId}>
								<button
									type="button"
									className="task-ref-link"
									onClick={() => props.history.push('/task_det/'+ cellData.taskId )}
								>
									{cellData.task_ref}
								</button>
								{isRowDirty(cellData) && <span className="row-edited">{t('costsUi.edited')}</span>}
							</div>
						)}
						/>			
					<Column width={tableWidth * 0.20} 
						label={t('actions.details')} 
						dataKey="site_ref"
						className="text-wrap"
						cellDataGetter={({dataKey, rowData}) => rowData}
						cellRenderer={cellTaskInfo}
						/>	 
					<Column width={tableWidth * 0.14} 
						label={t('common.contractor')} 
						dataKey="contractor" 
						cellDataGetter={({dataKey, rowData}) => rowData} 
						cellRenderer={cellContractor} 
						/>
					<Column width={tableWidth * 0.11} 
						label={t('fields.materials')}  
						dataKey="materials" 
						cellDataGetter={({dataKey, rowData}) => rowData} 
						cellRenderer={cellMaterials} 
						/>
					<Column width={tableWidth * 0.17} 
						label={t('fields.callOut')}  
						dataKey="callout_subtotal" 
						cellDataGetter={({dataKey, rowData}) => rowData} 
						cellRenderer={cellCallOut} 
						/>
					<Column width={tableWidth * 0.17} 
						label={t('fields.onSiteLabour')}  
						dataKey="onsite_subtotal" 
						cellDataGetter={({dataKey, rowData}) => rowData} 
						cellRenderer={cellLabour} 
						/>
					<Column width={tableWidth * 0.10} 
						label={t('costsUi.totalCosts')} 
						dataKey="total_cost" 
						cellDataGetter={({dataKey, rowData}) => rowData} 
						cellRenderer={cellTotalCost} 
						/>

					<Column width={tableWidth * 0.06} 
						label={t('costsUi.actions')} 
						dataKey="save" 
						cellDataGetter={({dataKey, rowData}) => rowData}					
						cellRenderer={({
							cellData
						}) => (
							<div className="action-cell">
								<Button size="sm" variant="primary" className="save-btn" onClick={() => handleSave(cellData)}>
									{t('common.save')} <FaCheck />
								</Button>
								<Button
									size="sm"
									variant="outline-secondary"
									className="reset-btn"
									onClick={() => handleClear(cellData)}
									title={t('costsUi.restoreValues')}
								>
									{t('common.clear')} <FaTimes/>
								</Button>
							</div>
						)}
						/>
				</Table>
				);
				}}
				 </AutoSizer>
			</div>
			
			)):(
				<div className="col-md-12 loading-container">
					<div className="loading-content">
						<Spinner animation="border" role="status" variant="primary" className="loading-spinner" />
						<div className="loading-text">{t('costsUi.loading')}</div>
						<div className="loading-subtext">{t('costsUi.pleaseWait')}</div>
					</div>
				</div>
			)}

		</div>
		</div>	
	</div>
	
	);

}


export default TaskCosts;
